// LINK

export const alphabeticalSorting = (selectorOptions) => {
    return selectorOptions.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
}

// RAPIPAGO

export const formatCompanyOptions = (options) =>
    options.map((option) => ({
        value: option.code,
        label: option.name,
    }));

export const isBarCode = (opt) => !opt.form.some((input) => input.dataType === "CBA");

export const formatModeOptions = (options) =>
    options.filter(isBarCode).map((option) => ({
        value: option.id,
        label: option.description,
        paymentType: option.paymentType,
        form: option.form,
    }));

export const amountTypes = {
    ABI: "ABI",
    ESC: "ESC",
};

export const validBillingDates = (billingList) =>
    billingList
        .filter((billing) => billing.expirationDate)
        .sort((a, b) => {
            const aa = a.expirationDate
                .split("/")
                .reverse()
                .join();
            const bb = b.expirationDate
                .split("/")
                .reverse()
                .join();
            // eslint-disable-next-line no-nested-ternary
            return aa < bb ? -1 : aa > bb ? 1 : 0;
        })
        .map((billing) => ({
            ...billing,
            expirationDate: billing.expirationDate
                .split("/")
                .reverse()
                .join("-"),
        }));

export const formatPreparedData = ({ form, billToPay, values, accountLabel, isCABpayment, companyName }) => {
    const communData = {
        paymentMethod: "̈PES",
        form,
        debitAccount: values.debitAccountId,
        accountLabel,
        paymentType: values.paymentType,
    };

    let prepareData = {};

    if (isCABpayment) {
        prepareData = {
            ...communData,
            companyCode: values.companyCode,
            companyName,
            amount: {
                quantity: values?.IV1,
                currency: "ARS",
            },
            paymentModeId: values.paymentType,
            isCABpayment,
        };
    } else {
        prepareData = {
            ...communData,
            companyCode: billToPay.companyCode,
            companyName: billToPay.companyName,
            clientId: billToPay.clientId,
            paymentModeId: billToPay.paymentModeId,
            barcode: billToPay.barcode,
            amount: {
                quantity: values.amountField.amount,
                currency: values.amountField.currency,
            },
            amountType: billToPay.amountType,
            expirationDate: billToPay.expirationDate,
            reference: billToPay.reference,
            additionalData: billToPay.additionalData,
            hash: billToPay.hash,
            type: billToPay.type,
            details: billToPay.details,
        };
    }

    return { prepareData };
};
